import { CloudOff } from "lucide-react";

import { Alert, AlertDescription } from "../../ui/alert";
import { Button } from "../../ui/button";
import {
  OPTRO_ACCESS_LIST_UNAVAILABLE_COPY,
  OPTRO_ACCESS_RETRY_ACTION,
} from "../../../lib/optroAccessMessages";
import { useRespectOptroPermissions } from "../../../hooks/useRespectOptroPermissions";

interface OptroAccessListNoticeProps {
  // The list response's `optroAccessUnavailable`: Optro couldn't be asked,
  // so every Optro-linked row was left out.
  unavailable: boolean;
  onRetry: () => void;
  className?: string;
}

/**
 * Non-blocking notice above the Controls, Work Steps and Fieldwork tables
 * saying linked rows are hidden because Optro access couldn't be checked.
 * Renders nothing otherwise, and never while `respect-optro-permissions` is
 * off or still resolving.
 */
export const OptroAccessListNotice = ({
  unavailable,
  onRetry,
  className,
}: OptroAccessListNoticeProps) => {
  const enforcement = useRespectOptroPermissions();
  if (!unavailable || enforcement !== "on") return null;

  return (
    <Alert data-testid="optro-access-list-notice" className={className}>
      <CloudOff className="h-4 w-4" aria-hidden />
      <div className="flex items-center justify-between gap-4">
        <AlertDescription>
          {OPTRO_ACCESS_LIST_UNAVAILABLE_COPY}
        </AlertDescription>
        <Button variant="outline" size="sm" onClick={onRetry}>
          {OPTRO_ACCESS_RETRY_ACTION}
        </Button>
      </div>
    </Alert>
  );
};
